/*
 * Title:  Rewards/EarnTabContent.tsx
 * Author: Chris Rosa
 * Email: chris@encore.fans
 * Description: Earn Content page content listing, click on list to expand.
 * Date: 30 Jun 2022
 * Copyright (c) Encore, 2022
 * Version:0.1.0
 */
import React from "react";
import { Fragment } from "react";
import close from "@assets/close.png";
import check from "@assets/check.png";
import Buttonlink from "@components/Button";
import { Dialog, Transition } from "@headlessui/react";
import { makeSecureUrl, routerLink } from "@helpers/common";
import Icon from "@components/Icon";
import copy_outline from "@assets/copy_outline.png";
import share from "@assets/share.png";
import copy_check from "@assets/copy_check.png";
import { toast } from "react-toastify";
import { connect } from "react-redux";
import QrPopUp from "@components/QrPopUp";

type Props = {};
type MyState = {
  open: boolean;
  toggleHeight: boolean;
  value: string;
  touchpoint:Object
};

class EarnContentItem extends React.Component<Props | any, MyState> {
  state: MyState = { open: false, value: "", toggleHeight: false, touchpoint:{} };

  toggleHandler = () => {
    this.setState({ toggleHeight: !this.state.toggleHeight });
  };

  viewQrcode = (actionItem) => {
    this.setState({touchpoint:actionItem});
  }



  render() {
    const { actionItem, item, notRedeemed, user, jwt_token, score_data } =
      this.props;
    const {touchpoint} = this.state;
    return (
      <>
        <a
        {...item.touchpoint!=="qrCode" &&  {href:
          !jwt_token
            ? `${routerLink(user?.username)}?ref=signin`
            : actionItem?.action !== "refer" || !jwt_token
            ? `${routerLink(user?.username)}/redeem`
            : null
        }}
          
          onClick={
            actionItem?.action !== "refer" || !jwt_token
              ? null
              : this.toggleHandler
          }
          className="block">
          <div className="relative">
            <div
              className={`${
                this.state.toggleHeight
                  ? "max-h-[100vh] transition-[max-height] ease-in-out duration-1000"
                  : "lg:max-h-[158px] max-h-[151px]"
              } bg-[#1D1D1D] p-[20px] transition-all duration-700 ease-in-out  rounded-[10px] mt-5 relative cursor-pointer overflow-hidden`}>
              {notRedeemed && (
                <div className="bg-green rounded-full p-[4px] h-5 w-5 flex items-center justify-center absolute -left-1 -top-1 overflow-hidden">
                  <img
                    src={check}
                    alt="Check"
                    className="object-contain w-full h-full"
                  />
                </div>
              )}
              <div className="flex items-center justify-between">
                <div className="bg-[#000]/50 h-[28px] lg:h-[32px] px-5 rounded-full flex items-center justify-center">
                  <p className="green lg:text-[14px] text-[12px] uppercase font-normal tracking-wider">
                    {actionItem.points} Points
                  </p>
                </div>
                <div className="-mt-1">
                  {item.url ? (
                    <a
                      rel="noreferrer"
                      href={makeSecureUrl(item.url)}
                      target={item.url ? "_blank" : ""}>
                      <Icon icon={item.touchpoint} item={actionItem} />
                    </a>
                  ) : item.url ? (
                    <a
                      rel="noreferrer"
                      href={makeSecureUrl(item.url)}
                      target={item.url ? "_blank" : ""}>
                      <Icon icon={item.touchpoint} item={actionItem} />
                    </a>
                  ) : (
                    <div onClick={()=>this.viewQrcode(actionItem)}>
                      <Icon icon={item.touchpoint} item={actionItem} />
                    </div>
                  )}
                </div>
              </div>
              <h4 className="font-medium text-white lg:text-[20px] text-[16px] mt-[15px]">
                {actionItem.title ? actionItem.title : "No Title"}
              </h4>
              <p
                className={`${
                  this.state.toggleHeight ? null : "truncate"
                } lightBlack text-[16px] font-normal tracking-wider mt-[15px]`}>
                {actionItem.description}
              </p>
              {actionItem?.action == "refer" && (
                <>
                  <div className="bg-[white]/10 h-[1.5px] w-full mt-[21px] mb-[18px]" />
                  <div className="mt-5">
                    <div className="flex items-center gap-x-3">
                      <div className="h-[35px] bg-[#555555] px-3 min-w-[215px] grow rounded-full flex items-center justify-center">
                        <p className="text-[white]/80 text-[15px] font-normal truncate">
                          {`${routerLink(
                            this.props.creatorData?.username?.toLowerCase()
                          )}/?invite=${score_data?.fanId}`}
                        </p>
                      </div>
                      <div
                        onClick={() => {
                          navigator.clipboard.writeText(
                            `${routerLink(
                              this.props.creatorData?.username?.toLowerCase()
                            )}/?invite=${score_data?.fanId}`
                          );
                          toast.success(
                            <div className="flex items-center gap-x-3 text-[black] text-[14px]">
                              <img
                                alt="logo"
                                src={copy_check}
                                className="h-[20px] w-[20px] object-contain"
                              />
                              Link copied!
                            </div>,
                            {
                              icon: false,
                              position: "bottom-center",
                              autoClose: 5000,
                              hideProgressBar: false,
                              closeOnClick: true,
                              pauseOnHover: true,
                              draggable: true,
                              // progress: undefined,
                              theme: "light",
                            }
                          );
                        }}
                        className="h-[35px] w-[35px] bg-[#FCC3A7] flex-shrink-0 rounded-full flex items-center justify-center">
                        <img
                          src={copy_outline}
                          className="h-[16px] w-[16px] object-contain"
                        />
                      </div>
                      {/* <div className="h-[35px] w-[35px] bg-[#FCC3A7] flex-shrink-0 rounded-full flex items-center justify-center">
                      <img
                        src={share}
                        className="object-contain w-[12px] h-[14px]"
                      />
                    </div> */}
                    </div>
                  </div>
                </>
              )}
            </div>

            {/* donations popup from bottom start  */}
            <Transition.Root show={this.state.open} as={Fragment}>
              <Dialog
                as="div"
                className="relative z-50"
                onClose={() => this.setState({ open: false })}>
                <Transition.Child
                  as={Fragment}
                  enter="ease-in-out duration-500"
                  enterFrom="opacity-0"
                  enterTo="opacity-100"
                  leave="ease-in-out duration-500"
                  leaveFrom="opacity-100"
                  leaveTo="opacity-0">
                  <div className="fixed inset-0 bg-[#000]/80 transition-opacity" />
                </Transition.Child>

                <div className="fixed inset-0 overflow-hidden">
                  <div className="absolute inset-0 overflow-hidden">
                    <div className="fixed inset-x-0 bottom-0 flex max-w-full pointer-events-none">
                      <Transition.Child
                        as={Fragment}
                        enter="transform transition ease-in-out duration-500 sm:duration-700"
                        enterFrom="translate-y-full"
                        enterTo="translate-y-0"
                        leave="transform transition ease-in-out duration-500 sm:duration-700"
                        leaveFrom="translate-y-0"
                        leaveTo="translate-y-full">
                        <Dialog.Panel className="relative w-screen h-full overflow-hidden pointer-events-auto">
                          <div className="bg-[#1D1D1D] py-6 shadow-xl px-4 sm:px-6 rounded-t-3xl">
                            <div className="bg-[#fff]/10 lg:w-12 w-9 mx-auto h-1 rounded-full" />
                            <div className="flex justify-end">
                              <button
                                type="button"
                                className="text-white rounded-md outline-none hover:text-white hover:opacity-70"
                                onClick={() => this.setState({ open: false })}>
                                <span className="sr-only">Close panel</span>
                                <img
                                  src={close}
                                  alt="Close"
                                  className="object-contain w-4 h-4"
                                />
                              </button>
                            </div>
                            <div className="mt-5 space-y-8">
                              <div>
                                <h4 className="font-medium text-white lg:text-[24px] text-[18px] text-center">
                                  Make a Donation
                                </h4>
                                <p className="mt-2 text-[#fff]/50 font-normal text-[16px] text-center uppercase tracking-wider">
                                  Earn 2.5 points for every $1 you donate.
                                </p>
                              </div>

                              <div className="bg-[#fff]/10 rounded-xl py-5 space-y-8 w-32 mx-auto">
                                <div className="text-center">
                                  <p className="text-[#fff]/50 font-normal text-[16px] uppercase tracking-wider">
                                    DONATION
                                  </p>
                                  <p className="primary font-semibold lg:text-[28px] text-[18px] uppercase tracking-wider">
                                    {/* ${value} */}
                                  </p>
                                </div>
                              </div>
                              <div className="max-w-[320px] mx-auto">
                                <input
                                  type="range"
                                  min="1"
                                  max="100"
                                  className="rangeSlider"
                                  value={this.state.value}
                                  // onChange={this._onChangeValue}
                                />
                                <div className="flex items-center justify-center mt-2 gap-x-1">
                                  <p className="text-[#fff]/50 font-normal text-[16px] tracking-wider">
                                    Value:
                                  </p>
                                  <p className="text-[#fff]/80 font-normal text-[16px] uppercase tracking-wider">
                                    {/* {value}$ */}
                                  </p>
                                </div>
                              </div>
                              <div className="text-center">
                                <p className="text-[#fff]/50 font-normal text-[16px] uppercase tracking-wider">
                                  POINTS EARNED
                                </p>
                                <p className="green font-medium lg:text-[24px] text-[18px] uppercase tracking-wider">
                                  {/* {value * 2.5} */}
                                </p>
                              </div>
                              <Buttonlink
                                text="donate now"
                                className="flex items-center justify-center text-white font-medium gap-x-1 bg-tile rounded-full h-[42px] w-[189px] mx-auto"
                              />
                            </div>
                          </div>
                        </Dialog.Panel>
                      </Transition.Child>
                    </div>
                  </div>
                </div>
              </Dialog>
            </Transition.Root>
            {/* donations popup from bottom end */}
            <QrPopUp 
              data={touchpoint}
              click={this.viewQrcode} 
              isFan={true}
            />
          </div>
        </a>
      </>
    );
  }
}

const mapStateToProps = ({ user, creator }) => {
  return {
    jwt_token: user.user.token,
    user: creator.data,
  };
};
export default connect(mapStateToProps)(EarnContentItem);
